module.exports = __webpack_public_path__ + "img/points-star-icon.308be2ba.png";